import { extractUserNames } from '@common/core/helpers/auth0-user'

import { addUserRegionalData, getUserRegionalData } from '../regional-user'
import type { InitializeRegionalInput, InitializeRegionalResult } from '../types'
import type { RegionalUser } from '../types/user.type'
import { addUserRegionalIdentity, getUserIdentities } from '../user'
import { hasRegionalIdentityForRegion } from '../utils/hasRegionalIdentityForRegion'
import { resolveRegionalIdentityForRegion } from '../utils/resolveRegionalIdentityForRegion'

export const addUserRegionalDataAndIdentity = async (
  input: InitializeRegionalInput,
  region: string,
  regionalData?: RegionalUser | null
): Promise<InitializeRegionalResult> => {
  let nextRegionalData = regionalData ?? input.currentUser?.regionalData ?? null
  const { auth0User, currentUser } = input

  const identities = await getUserIdentities()
  if (!hasRegionalIdentityForRegion(identities, region)) {
    await addUserRegionalIdentity(region)
  }

  if (!nextRegionalData) {
    const { email, firstName, lastName } = extractUserNames(auth0User, nextRegionalData)
    console.warn('Adding user regional data', { email, firstName, lastName })

    await addUserRegionalData({
      id: currentUser?.graftcodeUid ?? '',
      email,
      firstname: firstName,
      lastname: lastName,
      avatarUrl: null,
    })
    nextRegionalData = await getUserRegionalData()
  }

  const updatedIdentities = await getUserIdentities()
  const regionalIdentity = resolveRegionalIdentityForRegion(updatedIdentities, region)

  return { regionalData: nextRegionalData, regionalIdentity }
}
